export const MENSWEAR_DEPARTMENT_ID = 'menswear';
export const WOMENSWEAR_DEPARTMENT_ID = 'womenswear';
export const KIDSWEAR_DEPARTMENT_ID = 'kidswear';

export const TOP_LEVEL_DEPARTMENT_IDS = new Set([
  MENSWEAR_DEPARTMENT_ID,
  WOMENSWEAR_DEPARTMENT_ID,
  KIDSWEAR_DEPARTMENT_ID,
]);

export const TOP_LEVEL_CATEGORIES = new Set(['mens', 'womens', 'kids']);
